import { render, staticRenderFns } from "./UcUserInfo.vue?vue&type=template&id=2faa6ad6&scoped=true&"
import script from "./UcUserInfo.vue?vue&type=script&lang=js&"
export * from "./UcUserInfo.vue?vue&type=script&lang=js&"
import style0 from "./UcUserInfo.vue?vue&type=style&index=0&id=2faa6ad6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2faa6ad6",
  null
  
)

export default component.exports